import { axios } from "common/helpers"

export function get() {
  return axios.get("/api/icons")
}

export function update(icon) {
  const { company, iconSets, ...rest } = icon
  return axios.patch(`/api/icons/${icon.id}`, {
    ...rest,
    company: company?.id,
    iconSets: iconSets?.map(({ id }) => id)
  })
}

export function create(icon) {
  const { company, iconSets, ...rest } = icon
  return axios.post("/api/icons", {
    ...rest,
    company: company?.id,
    iconSets: iconSets?.map(({ id }) => id)
  })
}

export async function remove(id) {
  await axios.delete(`/api/icons/${id}`)
}
